var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusValue)?_c('span',{staticClass:"status",class:_vm.statusClass},[[_vm._v(_vm._s(_vm._f("ucwords")(_vm.statusValue ?? '--')))],(_vm.isOverdue)?[_vm._v(", past due")]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }